import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Socket } from "socket.io-client";
import { RootState } from "../..";

interface Props {
  socket: Socket | any;
  livechatSocket: boolean;
  executeConnectSocketEventWithReConnectAgent: (() => void); // Function to be stored

}

const INITIAL_STATE: Props = {
  socket: null,
  livechatSocket: false,
  executeConnectSocketEventWithReConnectAgent: () => undefined, // Function to be stored
};

const SocketSlice = createSlice({
  name: "SocketSlice",
  initialState: INITIAL_STATE,
  reducers: {
    setSocketStatus(state, { payload }: PayloadAction<any>) {
      state.socket = payload;
    },
    setLiveChatSocket(state, { payload }: PayloadAction<any>) {
      state.livechatSocket = payload;
    },
    setExecuteConnectSocketEventWithReConnectAgent(state, { payload }: PayloadAction<() => void>) {
      state.executeConnectSocketEventWithReConnectAgent = payload;
    },

    removeSocketStatus() {
      return INITIAL_STATE;
    },
  },
});

export default SocketSlice.reducer;

export const { removeSocketStatus, setSocketStatus, setLiveChatSocket, setExecuteConnectSocketEventWithReConnectAgent } =
  SocketSlice.actions;

export const socketStatusStore = (state: RootState) =>
  state.currrentSocketStatus;
